<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Compras/Requisição </label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col cols="12" sm="1">
          <v-btn
            color="info"
            to="/requisicao/criar"
            v-if="isAllowed(idModulo)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            ><v-radio value="AA">
              <template v-slot:label>
                <v-avatar size="25" color="red">
                  <span class="white--text text-h6">AA</span>
                </v-avatar>
                <div class="ma-1 text-h5">Ag. Aprovação</div>
              </template>
            </v-radio>
            <v-radio value="PA">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">AG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Analisado Pelo Gestor</div>
              </template>
            </v-radio>
            <v-radio value="B">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">B</span>
                </v-avatar>
                <div class="ma-1 text-h5">Baixada</div>
              </template>
            </v-radio>
            <v-radio value="D">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">D</span>
                </v-avatar>
                <div class="ma-1 text-h5">Declinada</div>
              </template>
            </v-radio>
            <v-radio value="I">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativa</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="2">
          <v-btn
            @click="baixarlista()"
            v-if="filteredList.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              :max="new Date().toISOString().substr(0, 10)"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :custom-filter="filter"
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <!--<template v-slot:item.autorizado="{ item }">
          {{ item.autorizado ? "Sim" : "Não" }}
        </template>
        <template v-slot:item.prioridade="{ item }">
          {{ item.prioridade == 1 ? "Normal" : "Emergencial" }}
        </template>-->
        <template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'AA'" color="red" size="24">
            <span class="white--text text-h5">AA</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PA'" color="green" size="24">
            <span class="white--text text-h5">AG</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'GS'" color="yellow" size="24">
            <span class="white--text text-h5">GS</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'AP'" color="yellow" size="24">
            <span class="white--text text-h5">AP</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'AT'" color="yellow" size="24">
            <span class="white--text text-h5">AT</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'B'" color="grey darken-1" size="24">
            <span class="white--text text-h5">B</span>
          </v-avatar>
          <v-avatar
            v-else-if="item.status == 'D'"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">D</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.id="{ item }">
          {{ item.nome == null ? item.id : item.nome }}
        </template>
        <!--<template v-slot:header="{ header }">
          <tr class="grey lighten-3">
            <th v-for="header in headers" :key="header.text">
              <div v-if="filters.hasOwnProperty(header.value)">
                <v-autocomplete
                  flat
                  hide-details
                  multiple
                  attach
                  chips
                  dense
                  clearable
                  :items="columnValueList(header.value)"
                  v-model="filters[header.value]"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 7">
                      <span>
                        {{ getStyle(item) }}
                      </span>
                    </v-chip>
                    <span
                      v-if="index === 7"
                      class="grey--text caption"
                      :style="{
                        resize: 'horizontal',
                        overflow: 'auto',
                        width: '100px',
                        height: '100px',
                      }"
                    >
                      (+{{ filters[header.value].length - 7 }} others)
                    </span>
                  </template>
                </v-autocomplete>
              </div>
            </th>
          </tr>
        </template>-->
        <template v-slot:item.idSolicitacao="{ item }">
          <span v-if="item.idSolicitacao && item.idSolicitacao !== 0">
            <a
              href="#"
              @click.prevent="abrirPdfSolicitacao(item)"
              class="text--primary font-weight-medium text-decoration-underline"
            >
              {{ item.idSolicitacao }}
            </a>
          </span>
          <span v-else>—</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span
              v-if="
                isAllowed(idModulo) &&
                statusPermite(item) &&
                item.mesmoRequisitante
              "
              >Editar</span
            >
            <span v-else>Visualizar</span>
          </v-tooltip>
          <v-tooltip v-if="isInactive(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="declinar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!podeDeclinarRegistro(item)"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Inativar</span>
          </v-tooltip>
          <v-tooltip v-if="isAllowed(idModulo) && isApproving(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                class="mr-2"
                @click="autorizar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!statusPermiteAprovar(item)"
              >
                mdi-check-bold
              </v-icon>
            </template>
            <span v-if="isAllowed(idModulo)">{{ textoTooltipAprovar(item) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data="{ item }">
          <span>{{
            new Date(item.data).toLocaleString().replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canDeclineModule,
  canInactivateModule,
  getUserPermission,
  getUserRoles,
  isLoggedUserAdmin,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";
import { downloadLista, getPdf } from "../../../services/requisicaoService";
import moment from "moment";
import { saveAs } from "file-saver";
import { getPdf as getSolicitacaoPdf } from "../../../services/solicitacaoService";
import { abrirJanelaPdf } from "@/services/pdfHelper";

export default {
  name: "listaRequisicao",
  data() {
    return {
      idModulo: 8,
      selectedFilter: "0",
      loading: false,
      search: "",
      showAtivo: false,
      apenasLeitura: false,
      active_tab: 2,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      arrayEvents: null,
      headers: [
        {
          text: "Req.",
          align: "start",
          value: "id",
        },
        { text: "Data Hora", value: "data" },
        { text: "UnidadeAdm", value: "unidadeAdm" },
        { text: "Requisitante", value: "requisitante" },
        { text: "Prioridade", value: "prioridade" },
        { text: "SC", value: "idSolicitacao" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions", sortable: false, width: "18%" },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      filters: {
        nome: [],
        data: [],
        unidadeAdm: [],
        local: [],
        requisitante: [],
        prioridade: [],
        centroCusto: [], // novo filtro adicionado
      },
    };
  },
  computed: {
    ...mapState("requisicao", ["requisicoes"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    filteredList() {
      const searchLower = this.search.toLowerCase();

      return this.requisicoes
        .filter((r) => {
          // 1. Filtro por texto digitado
          const buscaTexto =
            r.id.toString().toLowerCase().includes(searchLower) ||
            (r.unidadeAdm || "").toLowerCase().includes(searchLower) ||
            (r.local || "").toLowerCase().includes(searchLower) ||
            (r.requisitante || "").toLowerCase().includes(searchLower) ||
            (r.prioridade || "").toLowerCase().includes(searchLower) ||
            (r.produtos || []).some(
              (p) =>
                p.descricao?.toLowerCase().includes(searchLower) ||
                p.centroCusto?.toLowerCase().includes(searchLower)
            );

          // 2. Filtro por data (se datas forem preenchidas)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(r.data.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              new Date(r.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]));

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (f === "data") {
              const dataFormatada = new Date(r[f])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
              return this.filters[f].includes(dataFormatada);
            }

            if (f === "centroCusto") {
              return r.produtos.some((p) =>
                this.filters[f].includes(p.centroCusto)
              );
            }

            return this.filters[f].includes(r[f]);
          });

          // 4. Filtro por status (se não for "0")
          const statusOk =
            this.selectedFilter === "0" || r.status === this.selectedFilter;

          return buscaTexto && dataValida && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },
    /*filteredList() {
      var x = this.requisicoes.filter((r) => {
        return (
          (r.id.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            r.unidadeAdm.toLowerCase().includes(this.search.toLowerCase()) ||
            r.local.toLowerCase().includes(this.search.toLowerCase())) &&
          Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(r[f]);
          })
        );
      });
      if (x !== null && x.length > 0) {
        console.log(x);
        return x;
      } else {
        var result = this.requisicoes.filter((r) => {
          return (r.produtos.filter((p) =>
            p.descricao.toLowerCase().includes(this.search.toLowerCase())));
        });
        console.log(result);
        return result;
      }
    },*/
    /*filteredList() {
      try {
        var resulte = this.requisicoes.filter((r) => {
          return r.produtos.some((p) =>
            p.descricao.toLowerCase().includes(this.search.toLowerCase())
          );
        });

        console.log(resulte);
        return resulte;
      } catch (e) {
        alert('erro');
      }
    },*/
    /*return this.requisicoes.filter(r => r.produtos.includes(
         r.produtos.filter(p => p.descricao.toLowerCase().includes(this.search.toLowerCase()))));

      var result = this.requisicoes.map((req) => {
        return {
          ...req,
          produtos: req.produtos.filter((p) =>
            p.descricao.toLowerCase().includes(this.search.toLowerCase())
          ),
        };
      });
      console.log(result);
        alert(JSON.stringify(result));
      return result;
    },*/

    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("requisicao", [
      "atualizarRequisicoes",
      "atualizarRequisicao",
    ]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("centroCusto", ["atualizarCentrosCusto"]),

    columnValueList(val) {
      if (val == "data") {
        return this.requisicoes.map((d) =>
          new Date(d[val]).toLocaleString().replace(/(.*)\D\d+/, "$1")
        );
      } else {
        return this.requisicoes.map((d) => d[val]);
      }
    },
    editar(requisicao) {
      this.atualizarRequisicao(requisicao);
      if (this.isAllowed(this.idModulo) && this.statusPermite(requisicao)) {
        this.$router.push({
          path: "/requisicao/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/requisicao/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    declinar(requisicao) {
      this.atualizarRequisicao(requisicao);
      if (this.isInactive(this.idModulo) && this.podeDeclinarRegistro(requisicao)) {
        this.$router.push({
          path: "/requisicao/inativar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/requisicao/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    autorizar(requisicao) {
      this.atualizarRequisicao(requisicao);
        this.$router.push({
          path: "/requisicao/aprovar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
    },
    doAjax() {
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.centrosCusto || this.centrosCusto.length == 0) {
        this.atualizarCentrosCusto();
      }
    },
    async obter() {
      if (this.$store.getters["requisicao/getStatusAtualizacaoLista"]) {
        this.loading = true;
        await this.atualizarRequisicoes();
        this.loading = false;
      }
    },
    baixarlista() {
      //downloadLista();
      const blob = this.gerarExcel();
      const nome_arquivo = "requisicoes.xlsx";
      saveAs(blob, nome_arquivo);
    },
    show(item) {
      getPdf(item.id, abrirJanelaPdf());
    },
    isAllowed(id) {
      return getUserPermission(id);
    },
    isApproving(id) {
      return canApproveModule(id) || canDeclineModule(id);
    },
    isInactive(id) {
      return canInactivateModule(id);
    },
    statusPermite(requisicao) {
      return requisicao.status === "AA";
    },
    statusPermiteInativarAdmin(requisicao) {
      return ["AA", "AG", "PA", "D", "PG"].includes(requisicao.status);
    },
    podeDeclinarRegistro(requisicao) {
      return (
        (this.statusPermite(requisicao) && requisicao.mesmoRequisitante) ||
        (isLoggedUserAdmin() && this.statusPermiteInativarAdmin(requisicao))
      );
    },
    statusPermiteAprovar(requisicao) {
      const permite =
        requisicao.status === "AA" ||
        requisicao.status === "PA" ||
        requisicao.status === "D";
      logApprovalDiagnostics("Requisicao/Lista:Aprovar", explainApprovalButtonState({
        modulo: this.idModulo,
        registro: requisicao,
        action: "aprovar",
        statusPermitidos: ["AA", "PA", "D"],
      }));
      return permite;
    },
    statusPermiteDesaprovar(requisicao) {
      return requisicao.status === "PA";
    },
    textoTooltipAprovar(requisicao) {
      return this.statusPermiteDesaprovar(requisicao) ? "Desaprovar" : "Aprovar";
    },
    getStyle(value) {
      if (value == "1") {
        return "Normal";
      } else if (value == 2) {
        return "Emergencial";
      } else if (value == 0) {
        return "NA";
      } else {
        return value;
      }
    },
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
    filter(value, search, item) {
      if (this.selectedFilter == "0") {
        if (this.dataIni !== null && this.dataFim !== null) {
          return this.requisicoes.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              new Date(r.data.split("T")[0]) >=
                new Date(this.dataIni.split("T")[0]) &&
              new Date(r.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]) &&
              Object.keys(this.filters).every((f) => {
                if (f == "data") {
                  return (
                    this.filters[f].length < 1 ||
                    this.filters[f].includes(
                      new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")
                    )
                  );
                } else
                  return (
                    this.filters[f].length < 1 || this.filters[f].includes(r[f])
                  );
              })
            );
          });
        } else {
          return this.requisicoes.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              Object.keys(this.filters).every((f) => {
                if (f == "data") {
                  return (
                    this.filters[f].length < 1 ||
                    this.filters[f].includes(
                      new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")
                    )
                  );
                } else
                  return (
                    this.filters[f].length < 1 || this.filters[f].includes(r[f])
                  );
              })
            );
          });
        }
      } else {
        if (this.dataIni !== null && this.dataFim !== null) {
          return this.requisicoes.filter((r) => {
            return (
              (r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              new Date(r.data.split("T")[0]) >=
                new Date(this.dataIni.split("T")[0]) &&
              new Date(r.data.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]) &&
              Object.keys(this.filters).every((f) => {
                if (f == "data") {
                  return (
                    this.filters[f].length < 1 ||
                    this.filters[f].includes(
                      new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")
                    )
                  );
                } else
                  return (
                    this.filters[f].length < 1 || this.filters[f].includes(r[f])
                  );
              }) &&
              r.status == this.selectedFilter
            );
          });
        } else {
          return this.requisicoes.filter((r) => {
            return (
              ((r.id
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase()) &&
                r.unidadeAdm
                  .toLowerCase()
                  .includes(this.search.toLowerCase())) ||
                (r.idOrdemServico !== null &&
                  r.idOrdemServico
                    .toString()
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) ||
                r.local.toLowerCase().includes(this.search.toLowerCase()) ||
                r.requisitante
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.prioridade
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                r.produtos.some((p) =>
                  p.descricao.toLowerCase().includes(this.search.toLowerCase())
                )) &&
              Object.keys(this.filters).every((f) => {
                if (f == "data") {
                  return (
                    this.filters[f].length < 1 ||
                    this.filters[f].includes(
                      new Date(r[f]).toLocaleString().replace(/(.*)\D\d+/, "$1")
                    )
                  );
                } else
                  return (
                    this.filters[f].length < 1 || this.filters[f].includes(r[f])
                  );
              }) &&
              r.status == this.selectedFilter
            );
          });
        }
      }
    },
    abrirPdfSolicitacao(item) {
      getSolicitacaoPdf(item.idSolicitacao, abrirJanelaPdf());
    },
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Req." },
        { chave: "data", cabecalho: "Data Hora" },
        { chave: "unidadeAdm", cabecalho: "UnidadeAdm" },
        { chave: "local", cabecalho: "Local de Entrega" },
        { chave: "requisitante", cabecalho: "Requisitante" },
        { chave: "prioridade", cabecalho: "Prioridade" },
        { chave: "idSolicitacao", cabecalho: "SC" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "data") {
              return new Date(item[c.chave])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
            } else if (c.chave === "idSolicitacao") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col, i) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  mounted() {
    this.readOnly = !getUserPermission(1);
  },
  watch: {
    // quando o usuário muda a página na tabela, gravar na URL
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },

    // quando a URL muda (voltar do browser, entrar na tela), aplicar na tabela
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next }; // garante reatividade
        }
      },
    },
  },
  created: function () {
    const f = this.$route.query.selectedFilter;
    const allowed = ["0", "AA", "PA", "B", "D", "I"];
    this.selectedFilter = allowed.includes(f) ? f : "0";
    this.doAjax();
    this.obter();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>
